import { EXPENSE_REPORT_MUTATIONS } from '@/state/mutation-types'

export default {
  state: {
    reports: [],
  },
  mutations: {
    [EXPENSE_REPORT_MUTATIONS.SET_REPORTS](state, expenseReports) {
      state.reports = [...expenseReports]
    },
    [EXPENSE_REPORT_MUTATIONS.ADD_REPORT](state, expenseReport) {
      state.reports = [...state.reports, { ...expenseReport, autoAddExpense: true }]
    },
    [EXPENSE_REPORT_MUTATIONS.UPDATE_REPORT](state, { reportId, updatedReport }) {
      const reportIndex = state.reports.findIndex((report) => report.localId === reportId)
      state.reports[reportIndex] = { ...updatedReport }
    },
    [EXPENSE_REPORT_MUTATIONS.DELETE_REPORT](state, reportId) {
      state.reports = [...state.reports.filter((report) => report.localId !== reportId)]
    },

    [EXPENSE_REPORT_MUTATIONS.ADD_LINE_ITEM](state, { reportId, lineItem }) {
      const reportIndex = state.reports.findIndex((report) => report.localId === reportId)
      if (reportIndex === -1) return
      const lineItems = [...state.reports[reportIndex].expenses]
      lineItems.push(lineItem)
      state.reports[reportIndex].expenses = lineItems
    },
    [EXPENSE_REPORT_MUTATIONS.UPDATE_LINE_ITEM](state, { reportId, lineItem }) {
      const reportIndex = state.reports?.findIndex((report) => report.localId === reportId)
      const expenseIndex = state.reports?.[reportIndex]?.expenses?.findIndex(
        (expense) => expense.localId === lineItem.localId,
      )
      if (state.reports?.[reportIndex]?.expenses?.[expenseIndex]) {
        state.reports[reportIndex].expenses[expenseIndex] = { ...lineItem }
      }
    },
    [EXPENSE_REPORT_MUTATIONS.DELETE_LINE_ITEM](state, { reportId, lineItemId }) {
      const reportIndex = state.reports.findIndex((report) => report.localId === reportId)
      state.reports[reportIndex].expenses = state.reports[reportIndex].expenses.filter(
        (expense) => expense.localId !== lineItemId,
      )
    },
  },
  getters: {
    activeExpenseReports: (state) =>
      state.reports.filter((report) =>
        report.bill
          ? !report.bill.isRejected && !report.bill.isPayed && !report.bill.isExpresspayed
          : true,
      ),
    reimbursedExpenseReports: (state) =>
      state.reports.filter((report) =>
        report.bill ? report.bill.isPayed || report.bill.isExpresspayed : false,
      ),
    billedExpensesAmount: (state, getters) =>
      Number(
        getters.reimbursedExpenseReports
          .map((report) =>
            report.expenses.map((expense) => expense.amount).reduce((a, b) => a + b, 0),
          )
          .reduce((a, b) => a + b, 0) / 100,
      ).toFixed(2),
    unBilledExpensesAmount: (state, getters) =>
      Number(
        getters.activeExpenseReports
          .map((report) =>
            report.expenses.map((expense) => expense.amount).reduce((a, b) => a + b, 0),
          )
          .reduce((a, b) => a + b, 0) / 100,
      ).toFixed(2),
  },
}
